import * as yup from 'yup';

import {PHONE_NUMBER_REGEX} from '../../../utils/validation';

export const AcceptOrderSchema = yup.object().shape({
  person: yup.string().oneOf(['someone_else', 'me']),
  firstName: yup.string().when('person', {
    is: 'someone_else',
    then: yup.string().required('This is a required field'),
  }),
  lastName: yup.string().when('person', {
    is: 'someone_else',
    then: yup.string().required('This is a required field'),
  }),
  mobile: yup.string().when('person', {
    is: 'someone_else',
    then: yup
      .string()
      .required('This is a required field')
      .matches(
        PHONE_NUMBER_REGEX,
        'Please enter a valid Australian phone number',
      ),
  }),
});
